import React, { useEffect } from 'react'
import { createContext, useState } from 'react'
import { GetGeneralRules } from '../redux/api/generalRules'
import { useLocation } from 'react-router-dom'
import _ from 'lodash'

const GeneralContext = createContext({})

export const GeneralProvider = ({ children }) => {
    const [listState, setListState] = useState([])
    const location = useLocation()
    const [GeneralRules, setGeneralRules] = useState([])

    const getGeneralRules = () => {
        GetGeneralRules()
            .then((res) => { if (res) setGeneralRules(res) })
            .catch((err) => console.error('Failed to load general rules:', err))
    }

    useEffect(() => {
        if (!location?.pathname || location?.pathname === '/auth/login') return
        if (!_.isEmpty(GeneralRules)) return // GeneralRules omitido das deps intencionalmente — adicionar causaria loop

        let cancelled = false
        GetGeneralRules()
            .then((res) => { if (res && !cancelled) setGeneralRules(res) })
            .catch((err) => { if (!cancelled) console.error('Failed to load general rules:', err) })

        return () => { cancelled = true }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname])

    return (
        <GeneralContext.Provider
            value={{
                listState,
                setListState,
                GeneralRules,
                getGeneralRules,
            }}
        >
            {children}
        </GeneralContext.Provider>
    )
}

export default GeneralContext
